import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const taskMonitor: ThemeUICSSObject = {
  '.taskMonitor__warning': {
    backgroundColor: 'palette.warning.light',
    color: 'palette.warning.contrastText',
  },
  '.taskMonitor__overdue': {
    backgroundColor: 'palette.error.light',
    color: 'palette.error.contrastText',
  },
  '& > div': {
    maxHeight: '500px',
    '& > div': {
      height: '100%',
      overflowX: 'auto',

      '&.noFixedWidth': {
        overflowX: 'auto',
      },
    },
  },
  /* PREPEND HERE */
};

export default taskMonitor;
